import { paginationStyles } from "@insite/content-library/Widgets/ProductList/ProductListPagination";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

paginationStyles.pagination = {
    cssOverrides: {
        perPageSelect: css`
            label {
                width: unset;
                position: relative;
                z-index: 100;
                left: 120px;
                top: -18px;
                font-size: 12px;
                font-weight: 600;
                background: white;
                color: gray;
                height: fit-content;
                margin: 9px 15px 0px 0px;
                padding: 0px;
            }
            select[class^="SelectStyle"] {
                background: #fff;
                width: 130px;
            }
            span[class^="IconWrapper"] {
                background: #fff;
                right: -50px;
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: flex;
                        justify-content: flex-end;
                        padding-top: 5px;
                        padding-right: 50px;
                    `,
                    css`
                        display: flex;
                        justify-content: flex-end;
                        padding-top: 5px;
                        padding-right: 50px;
                    `,
                    css`
                        display: flex;
                        justify-content: flex-end;
                        padding-top: 5px;
                        padding-right: 50px;
                    `,
                    null,
                    null,
                ])}
        `,

        pagination: css`
            > nav {
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            display: flex;
                            justify-content: flex-end;
                            padding-right: 50px;
                        `,
                        css`
                            display: flex;
                            justify-content: flex-end;
                            padding-right: 50px;
                        `,
                        css`
                            display: flex;
                            justify-content: flex-end;
                            padding-right: 50px;
                        `,
                        null,
                        null,
                    ])}
            }
        `,
        currentButton: css`
            background-color: #ffffff;
            color: #333 !important;
            > span {
                font-size: 18px;
                font-weight: 600;
                color: #333;
            }
            &:hover {
                background-color: #ffffff !important;
                color: #333 !important;
            }
        `,
    },
};
